export default "__VITE_ASSET__R28Oxtfl__"